import type { FieldElementProps, FieldElement } from "@formisch/preact";

// Formisch types ref as (element: FieldElement) => void but Preact expects
// (instance: T | null) => void. The runtime handles null correctly — the type
// definition is just missing | null. This override fixes the mismatch so we
// can spread props onto Preact JSX elements without `as any`.
export type FieldProps = Omit<FieldElementProps, "ref"> & {
  ref: (element: FieldElement | null) => void;
};

export const inputClass = "fv-focus-ring px-3 py-2.5 border rounded-theme text-sm text-theme-fg bg-theme-card outline-none transition-[border-color,box-shadow] duration-150 ease-out font-[inherit] disabled:opacity-60 disabled:cursor-not-allowed";
